export default {
  MODAL_PORTAL_ID: "modal-portal",
}
